import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgSelectComponent} from '@ng-select/ng-select';
import {Subscription} from 'rxjs';
import {IYii} from '../../../globals';
import {AssignmentService} from '../services/AssignmentService';
import {ProgressBar} from 'primeng/progressbar';
import {ApproversService} from '../services/ApproversService';
import {ILoadedUser, SystemService} from '../services/SystemService';

declare var Yii: IYii;

@Component({
  selector: 'ng-assignments-approvers',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgSelectComponent,
    ProgressBar
  ],
  templateUrl: './assignments-approvers.html'
})
export class AssignmentsApprovers implements OnInit, OnDestroy {
  public Yii = Yii;
  private subs: Subscription[] = [];

  public approvers: ILoadedUser[] = [];
  public assigned: ILoadedUser[] = [];

  constructor(
    public asvc: AssignmentService,
    public approversvc: ApproversService,
    public sysvc: SystemService,
  ) {
  }

  Init() {
    this.approversvc.Load()
      .then(assignedApprovers => {
        this.sysvc.GetManagers(this.asvc.GetCurrentChainId())
          .then(managers => {
            this.approvers = managers
            this.assigned = managers.filter(
              m => assignedApprovers.find(a => a.id === m.id) !== undefined
            )
          })
      })
  }

  ngOnInit(): void {
    this.subs.push(this.asvc.OnChainChanged.subscribe({next: () => this.Init()}))
    this.subs.push(this.asvc.OnBranchChanged.subscribe({next: () => this.Init()}))
    this.Init();
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  sync() {
    this.approversvc.Sync(this.assigned.map(a => a.id))
  }
}
